module.exports = __webpack_public_path__ + "static/media/art56.c58f4807.jpg";